import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
})
export class CustomerComponent implements OnInit {
  subMenuItems: any = [];
  constructor(
    private readonly userService: UserService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // this.subMenuItems = this.subMenuItems.filter((item) => {
    //   return item.role.includes(userRole);
    // });
    setTimeout(() => {
      const userRole: string = this.userService.getUserRole();
      console.log(userRole);
      let self = this;
      this.getAllMenu();
      let categoriesMenu = JSON.parse(
        localStorage.getItem('navigations') as any
      );
      // will be removed
      if (categoriesMenu.includes('onboarding')) {
        categoriesMenu.push('partner-onboarding');
      }
      if (categoriesMenu.includes('partner-profile')) {
        categoriesMenu.push('edit-portal-builder');
      }
      if (categoriesMenu.includes('customer-profile')) {
        categoriesMenu.push('edit-customer');
      }
      self.subMenuItems = this.subMenuItems.filter((item: any) => {
        let titleForList = item.name.toLowerCase().split(' ').join('-');
        return categoriesMenu.includes(titleForList);
      });

      if (userRole == 'partner') {
        console.log(this.subMenuItems);
        this.subMenuItems.forEach((item: any) => {
          if (item.name == 'Partner Onboarding') {
            item.name = 'Reseller Onboarding';
          }
          // if(item.name == 'Customer Profile') {
          //   item.name = 'Reseller Profile';
          // }
        });
      }
      if (userRole == 'reseller') {
        console.log(this.subMenuItems);
        this.subMenuItems.forEach((item: any) => {
          if (item.name == 'Partner Onboarding') {
            item.name = 'Merchant Onboarding';
          }
          if (item.name == 'Customer Profile') {
            item.name = 'Merchant Profile';
          }
        });
      }
      for (let i = 0; i <= self.subMenuItems.length; i++) {
        console.log('sub', this.subMenuItems, i);
        let titleForList = self.subMenuItems[i].name
          .toLowerCase()
          .split(' ')
          .join('-');
        // if(categoriesMenu.includes(titleForList)) {
        console.log('t', titleForList, i);
        console.log('index', i);
        this.router.navigate([`home/customer/${self.subMenuItems[i].route}`]);
        break;
        // }
      }

      console.log(this.subMenuItems);
    }, 0);
  }

  getAllMenu() {
    this.subMenuItems = [
      {
        image: '',
        name: 'Organization List',
        route: 'organization-list',
        role: ['admin', 'manager', 'employee']
      },

      // {
      //   image: '',
      //   name: 'Organization',
      //   route: 'add-organization',
      //   role: ['admin', 'manager', 'employee']
      // },
      {
        image: '',
        name: 'User List',
        route: 'user-list',
        role: ['admin', 'manager', 'employee']
      },
      // {
      //   image: '',
      //   name: 'Add User',
      //   route: 'add-user',
      //   role: ['admin', 'manager', 'employee']
      // },

      {
        image: '',
        name: 'Staff List',
        route: 'staff-list',
        role: ['admin', 'manager', 'employee']
      },
      // {
      //   image: '',
      //   name: 'Add Staff',
      //   route: 'staff',
      //   role: ['admin', 'manager', 'employee']
      // },

      {
        image: '',
        name: 'Support Ticket',
        route: 'add-support',
        role: ['admin', 'manager', 'employee']
      },
      // {
      //   image: '',
      //   name: 'Vendor Profile',
      //   route: 'partnerProfile',
      //   role: ['admin'],
      // },
      // {
      //   image: '',
      //   name: 'Edit Portal Builder',
      //   route: 'addEditPortalBuilder',
      //   hidden: true,
      //   role: ['merchant', 'admin'],
      // },
      // {
      //   image: '',
      //   name: 'Customer Profile',
      //   route: 'customerProfile',
      //   role: ['merchant', 'admin'],
      // },
      // {
      //   image: '',
      //   name: 'Edit Customer',
      //   route: 'editcustomerProfile',
      //   hidden: true,
      //   role: ['merchant', 'admin'],
      // },

    ];
  }
}
